import { createContext, useContext } from 'react';

const OrderProductionNamePrefixContext = createContext('');

export const useOrderProductionNamePrefix = () =>
    useContext(OrderProductionNamePrefixContext);

export const OrderProductionNamePrefixProvider =
    OrderProductionNamePrefixContext.Provider;
